export enum EAdminBootstrapQueryKey {
  ADMIN_BOOTSTRAP = 'ADMIN_BOOTSTRAP',
}
